<lu-select
	[formControl]="formControl | fromAbstractToFormControl"
	[urlOptions]="urlOptions"
	[options]="selectOptions"
	[parentForm]="field.options.parentForm"
	[items]="items"
	(selectInstanceReady)="selectReady($event)"
	(loadedData)="loadedData($event)"
	[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
	(ngModelChange)="change($event)">
</lu-select>
